import {SettingsNavigationProperty} from "@pata/settings";
import {getTranslations} from "next-intl/server";

export default async function fetchInformation(): Promise<SettingsNavigationProperty[]> {
    const t = await getTranslations('Navigation')
    
    return [
        { name: t('about-us'), path: "/about-us", htmlId: 38 },
        { name: t('about-us#aktualitates'), path: "/about-us#aktualitates", htmlId: 123 },
        { name: t('about-us#vakances'), path: "/about-us#vakances", htmlId: 124 },
        { name: t('contact-us#rekviziti'), path: "/contact-us#rekviziti", htmlId: 125 },
        { name: t('code-of-conduct'), path: "/code-of-conduct", htmlId: 251 },
        { name: t('whistleblowing-policy'), path: "/whistleblowing-policy", htmlId: 252 },
        { name: t('privacy-policy'), path: "/privacy-policy", htmlId: 291 },
        { name: t('contact-us'), path: "/contact-us", htmlId: 37 },
    ]
}